module.exports = __webpack_public_path__ + "img/report-6.31670ac7.jpg";